/**
 * Auto-scroll to highlighted search term on page load
 * Minimal JavaScript for search result navigation
 */
document.addEventListener('DOMContentLoaded', function () {
  const urlParams = new URLSearchParams(window.location.search);
  const highlightTerm = urlParams.get('highlight');

  if (highlightTerm && highlightTerm.trim() !== '') {
    // Add CSS for highlighting
    const style = document.createElement('style');

    style.textContent = `
      .search-highlight {
        background-color: var(--color-brand-tertiary);
        color: var(--color-slate-900);
        padding: 0.125rem 0.25rem;
        border-radius: 0.25rem;
        font-weight: 600;
        box-decoration-break: clone;
        -webkit-box-decoration-break: clone;
      }
    `;
    document.head.appendChild(style);

    const containers = Array.from(document.querySelectorAll('section .page-container')).filter(
      (el) => el.offsetParent !== null
    );

    if (containers.length === 0) {
      containers.push(document.body); // fallback
    }

    let firstMatch = null;
    let matchCount = 0;

    containers.forEach((container) => {
      const textNodes = getTextNodes(container);

      textNodes.forEach((node) => {
        const text = node.textContent;
        // Create case-insensitive regex to find all matches with original case
        const escapedTerm = highlightTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const regex = new RegExp(escapedTerm, 'gi');
        const match = text.match(regex);

        if (match) {
          matchCount++;

          // Replace all occurrences while preserving original case
          const highlightedText = text.replace(regex, '<span class="search-highlight">$&</span>');
          const wrapper = document.createElement('span');

          wrapper.innerHTML = highlightedText;
          node.parentNode.replaceChild(wrapper, node);

          if (!firstMatch) {
            firstMatch = wrapper.querySelector('.search-highlight');
          }
        }
      });
    });

    const allDivs = Array.from(document.querySelectorAll('div'));

    let matchingDivs = 0;

    allDivs.forEach((div, idx) => {
      if (div.innerText && div.innerText.toLowerCase().includes(highlightTerm.toLowerCase())) {
        matchingDivs++;
      }
    });

    // Scroll to first match
    if (firstMatch) {
      setTimeout(() => {
        firstMatch.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }, 100);
    }
  }
});

/**
 * Get all text nodes in element
 */
function getTextNodes(element) {
  const textNodes = [];

  const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, {
    acceptNode: function (node) {
      // Skip script and style elements
      if (node.parentElement.tagName === 'SCRIPT' || node.parentElement.tagName === 'STYLE') {
        return NodeFilter.FILTER_REJECT;
      }

      // Only include nodes with non-whitespace text
      if (node.textContent.trim().length > 0) {
        return NodeFilter.FILTER_ACCEPT;
      }

      return NodeFilter.FILTER_REJECT;
    },
  });

  let currentNode;

  while ((currentNode = walker.nextNode())) {
    textNodes.push(currentNode);
  }

  return textNodes;
}
